import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApiService, DigitalAssetScreenSize, HtmlTemplateParameters } from "clearline-api";
import { HtmlTemplateDirective } from "../html-template.directive";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { HtmlTemplateBaseComponent } from "../html-template-base-component";
import { CfsTemplateErrorTypes } from "../../cfs-template-errors";
import { catchError, take, tap } from "rxjs/operators";
import { of } from "rxjs";
import { document } from "ngx-bootstrap/utils";

@Component({
  selector: "lib-cmc-qr-code-template",
  standalone: true,
  imports: [CommonModule, HtmlTemplateDirective],
  templateUrl: "./cmc-qr-code-template.component.html",
  styleUrls: ["./cmc-qr-code-template.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmcQrCodeTemplateComponent extends HtmlTemplateBaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() parameters: HtmlTemplateParameters | null = null;

  @ViewChild("mainImageWrapper", { static: false }) mainImageWrapper: ElementRef | null = null;

  protected readonly DigitalAssetScreenSize = DigitalAssetScreenSize;
  protected mainImageHtml: SafeHtml | null = null;

  private mainImageMutationObserver: MutationObserver | null = null;

  constructor(private sanitizer: DomSanitizer, private apiService: ApiService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (!this.parameters) {
      this.setError(CfsTemplateErrorTypes.EmptyData);
      return;
    }

    if (!this.parameters.logoUrl) {
      this.onLogoError("");
    }
    if (!this.parameters.qrCodeUrl) {
      this.onQrCodeError("");
    }
    if (!this.parameters.imageUrl) {
      this.onMainImageError("");
    } else {
      const imageUrl = this.parameters.imageUrl;
      this.apiService
        .getTextByFullUrl(imageUrl)
        .pipe(
          tap((imageContent: string) => {
            this.mainImageHtml = this.sanitizer.bypassSecurityTrustHtml(imageContent);
            this.onMainImageLoaded();
          }),
          catchError(() => {
            this.onMainImageError(imageUrl);
            return of(null);
          }),
          take(1)
        )
        .subscribe(() => {});
    }
  }

  ngAfterViewInit() {
    if (this.mainImageWrapper?.nativeElement) {
      this.mainImageMutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.addedNodes.length > 0) {
            const svgElement = this.mainImageWrapper!.nativeElement.querySelector("svg");

            if (svgElement) {
              const images = svgElement.querySelectorAll("image");
              let errorHandled = false;

              images.forEach((img: SVGImageElement) => {
                img.addEventListener("error", () => {
                  if (!errorHandled) {
                    errorHandled = true;
                    this.onMainImageError(this.parameters?.imageUrl);
                  }
                });
              });
            }
            this.onMainImageLoaded();
            this.mainImageMutationObserver?.disconnect();
            break;
          }
        }
      });

      this.mainImageMutationObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  ngOnDestroy() {
    this.mainImageMutationObserver?.disconnect();
  }
}
